import React from 'react'
import { Container } from './Container'
import { Features } from './Features'

export const App = () => (
  <Container><Features /></Container>
)



// WEBPACK FOOTER //
// ./sampleProject/src/App.tsx